export default "__VITE_ASSET__CEgUHKhw__"